var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { database, auth } from '../../config/firebaseConfig';
import * as firebaseAuth from 'firebase/auth';
import { ref, set } from 'firebase/database';
import mixpanel from '../../config/mixpanelConfig';
import * as Sentry from '@sentry/react';
import { unsubscribeWorkspaceListener, unsubscribeCollectionListener, } from './index';
var googleProvider = new firebaseAuth.GoogleAuthProvider();
export var signIn = function (userId, emailVerified) {
    mixpanel.identify(userId);
    Sentry.setUser({ id: userId });
    /** This is probably redundat here or call firebase twice,
     * but it's needed in order to store the token in the authToken const.
     */
    _refreshUserToken();
    return {
        type: 'auth/signIn',
        payload: {
            isSignedIn: true,
            userId: userId,
            emailVerified: emailVerified,
        },
    };
};
export var signOut = function () {
    unsubscribeCollectionListener();
    unsubscribeWorkspaceListener();
    firebaseAuth.signOut(auth);
    mixpanel.reset();
    Sentry.setUser(null);
    return {
        type: 'auth/signOut',
    };
};
export var checkIfUserIsLoggedIn = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                firebaseAuth.onAuthStateChanged(auth, function (user) {
                    dispatch({ type: 'auth/checkIfUserIsLoggedIn/fulfilled' });
                    var isSignedIn = getState().auth.isSignedIn;
                    if (user) {
                        // force refresh of the token in order to propagate any update to the claims
                        // (needed for access permissions in Storage)
                        user
                            .getIdToken(true)
                            .then(function (_idToken) {
                            idToken = _idToken;
                            if (!isSignedIn) {
                                // sign in user
                                dispatch(signIn(user.uid, user.emailVerified));
                            }
                        })
                            .then(function () {
                            user.getIdTokenResult(true).then(function (token) {
                                if (token.claims.moderator) {
                                    dispatch({ type: 'user/isModerator' });
                                }
                            });
                            resolve(true);
                        });
                    }
                    else {
                        // sign out user
                        dispatch(signOut());
                        resolve(false);
                    }
                }, function (err) {
                    console.log(err);
                    dispatch({ type: 'auth/checkIfUserIsLoggedIn/rejected' });
                    reject(err);
                });
            })];
    });
}); }; };
/**
 * Firebase signed id token to be added to REST requests
 * that need authentication.
 */
export var idToken;
/**
 * @returns The new idToken
 */
export var _refreshUserToken = function () {
    var _a;
    return (_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken(true).then(function (idToken) {
        idToken = idToken;
        return idToken;
    });
};
// ---------------------------------------------
// EMAIL / PASSWORD AUTHENTICATION METHODS
// ---------------------------------------------
export var _createUserWithEmailAndPassword = function (email, password) {
    return firebaseAuth
        .createUserWithEmailAndPassword(auth, email, password)
        .then(function (_a) {
        var user = _a.user;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, firebaseAuth.sendEmailVerification(user)
                        // add user to mailchimp
                    ];
                    case 1:
                        _b.sent();
                        // add user to mailchimp
                        _addUserToMailChimp(email);
                        mixpanel.track('sign up - unverified', {
                            provider: 'email/password',
                        });
                        return [2 /*return*/, user.uid];
                }
            });
        });
    });
};
export var _checkIfUserExist = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebaseAuth.fetchSignInMethodsForEmail(auth, email)];
            case 1:
                response = (_a.sent()) || [];
                if (response === null || response === void 0 ? void 0 : response.length) {
                    // email is already associated to an account - Sign In
                    console.log('checkIfUserExist', 'user exists');
                }
                else {
                    // email is new - Sign Up
                    console.log('checkIfUserExist', 'user doesnt exist');
                }
                return [2 /*return*/, !!response.length];
        }
    });
}); };
export var _loginWithEmailAndPassword = function (email, password) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, firebaseAuth
                .signInWithEmailAndPassword(auth, email, password)
                .then(function (_a) {
                var user = _a.user;
                if (user.displayName) {
                    mixpanel.track('log in', {
                        provider: 'email/password',
                    });
                }
                else if (user.emailVerified) {
                    mixpanel.track('sign up - completed', {
                        provider: 'email/password',
                    });
                }
                else if (!user.emailVerified) {
                    // re-send email verification
                    firebaseAuth.sendEmailVerification(user);
                }
            })
            // NB. The user is autom. signed in by checkIfUserIsLoggedIn()
        ];
    });
}); };
export var sendPasswordResetEmail = function (email) {
    return firebaseAuth.sendPasswordResetEmail(auth, email);
};
// ---------------------------------------------
// GOOGLE AUTHENTICATION METHODS
// ---------------------------------------------
/**
 * Function that extends Firebase's signInWithRedirect method
 */
export var signInWithRedirect = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebaseAuth.signInWithRedirect(auth, googleProvider)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * NB. the user is automatically signed in by checkIfUserIsLoggedIn()
 */
export var _getRedirectResult = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, firebaseAuth.getRedirectResult(auth).then(function (result) {
                if (!result) {
                    // this will run in case it's a first load
                    // (no data since Firebase hasn't returned anything yet.
                    return null;
                }
                else {
                    _handleGoogleSigninCompletion(result);
                    return result.user;
                }
            })];
    });
}); };
/**
 * NB. the user is automatically signed in by checkIfUserIsLoggedIn()
 */
export var _signInWithPopup = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, firebaseAuth
                .signInWithPopup(auth, googleProvider)
                .then(function (result) { return _handleGoogleSigninCompletion(result); })];
    });
}); };
/**
 * Handles:
 * - Electron token upload
 * - Mailchimp list for new users
 * - Mixpanel tracking
 */
var _handleGoogleSigninCompletion = function (userCredential) { return __awaiter(void 0, void 0, void 0, function () {
    var user, electronAuthCode, isNewUser;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                user = userCredential.user;
                electronAuthCode = new URLSearchParams(window.location.search).get('auth-code');
                if (!electronAuthCode) return [3 /*break*/, 2];
                return [4 /*yield*/, _uploadIdToken(userCredential, electronAuthCode)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                isNewUser = firebaseAuth.getAdditionalUserInfo(userCredential).isNewUser;
                if (isNewUser) {
                    mixpanel.track('sign up - completed', {
                        provider: 'google',
                    });
                    // also add user to mailchimp
                    _addUserToMailChimp(user.email);
                }
                else {
                    mixpanel.track('log in', {
                        provider: 'google',
                    });
                }
                return [2 /*return*/];
        }
    });
}); };
/**
 * Function that uploads the idToken to Firebase's database
 * in order for Electron to fetch it and process the authentication
 */
var _uploadIdToken = function (userCredential, authCode) { return __awaiter(void 0, void 0, void 0, function () {
    var idToken;
    return __generator(this, function (_a) {
        idToken = firebaseAuth.GoogleAuthProvider.credentialFromResult(userCredential).idToken;
        return [2 /*return*/, set(ref(database, 'auth-codes/' + authCode), {
                idToken: idToken,
            })
                .then(function () {
                console.log('token sent!');
            })
                .catch(function (error) {
                console.log(error.message);
            })];
    });
}); };
var _addUserToMailChimp = function (email) {
    if (process.env.NODE_ENV !== 'development') {
        axios.post("/api/newsletter/add-user", {
            email: email,
            requireConfirmation: false,
        });
    }
};
